import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'roo-ui/components';
import Header from './Header';
import Info from './Info';
import ProcessingIndicator from './ProcessingIndicator';
import Logo from './Logo';

import { fixBodyScroll, unfixBodyScroll } from '@qga/components';

const ProcessingRequest = ({ header, info, infoAfter10Sec, ...props }) => {
  useEffect(() => {
    fixBodyScroll();
    return () => unfixBodyScroll();
  }, []);

  return (
    <Flex
      zIndex="processingScreen"
      position="fixed"
      flexDirection="column"
      top="0"
      left="0"
      minHeight="100vh"
      minWidth="100vw"
      maxHeight="100vh"
      maxWidth="100vw"
      bg="white"
      justifyContent="center"
      alignItems="center"
      data-testid="processing-cancellation-modal"
      {...props}
    >
      <Logo />
      <Header px="4" message={header} />
      <Info mx="20%" mt={[4, 9]} message={info} messageAfter10Sec={infoAfter10Sec} />
      <ProcessingIndicator my={[7, 15]} />
    </Flex>
  );
};

ProcessingRequest.propTypes = {
  header: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  infoAfter10Sec: PropTypes.string.isRequired,
};

export default ProcessingRequest;
